import './card-notification.scss'
// components
import Card from '../../../atoms/card/card'

const CardNotification = props => {
	const { title, time, description, active = true, onClick } = props

	return (
		<Card classes={`m-card-notification ${active && 'active'}`} onClick={onClick}>
			<div className='m-card-notification__header'>
				{title && <p>{title}</p>}
				{time && <span>{time}</span>}
			</div>
			{description && <p>{description}</p>}
		</Card>
	)
}

export default CardNotification
